import type { IAuthor, ISiteNavigation } from '@anywayseo/tools';
import { StaticImage } from 'gatsby-plugin-image';

export const author: IAuthor = {
  name: 'Rafael Monteiro',
  role: 'Especialista em Jogos',
  bio: 'Meu nome é Rafael Monteiro e sou autor especializado no site plinko-casino.guru. Meu trabalho está relacionado à análise e avaliação de jogos modernos de crash, como o Plinko. Procuro ajudar os usuários a entenderem a mecânica dos jogos, escolherem plataformas confiáveis e aprenderem estratégias para uma melhor experiência de jogo. Sou apaixonado pela indústria de apostas desde 2018 e me esforço para torná-la mais transparente e compreensível para todos os jogadores. Meu objetivo é ajudar você a aproveitar uma experiência de jogo emocionante e encontrar as melhores ofertas do mercado.',
  avatar: (
    <StaticImage
      src={'./assets/rafael-monteiro-casion-expert.jpg'}
      alt='Rafael Monteiro'
      style={{ borderRadius: '50%' }}
    />
  ),
};

export const localNavigation: ISiteNavigation = {
  header: {},
  footer: {
    ['pt-BR']: [
      { slug: 'politica-de-privacidade', label: 'Política de Privacidade' },
      { slug: 'politica-de-cookies', label: 'Política de Cookies' },
      { slug: 'termos-e-condicoes', label: 'Termos e Condições' },
      { slug: 'contatos', label: 'Contatos' },
    ],
  },
};
